export class EnviarEmail {
    constructor(
        public email: string = '',
    ) { }
}